var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/videoPlay.027bf23c.png","uri@2x": __webpack_public_path__ + "static/media/videoPlay.027bf23c.png","uri@3x": __webpack_public_path__ + "static/media/videoPlay.f77f61da.png",
    width: 32,
    height: 32
});